import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Button, ButtonGroup, FormFeedback } from 'reactstrap';

class HousingStatusFields extends Component {
  render() {
    return (
      <div className="housing-status-fields">
        <FormGroup>
          <Label for="status">Housing Status</Label>
          <ButtonGroup className={(this.props.validation.housingStatus.isInvalid) ? "is-invalid" : ""}>
            <Button className={(this.props.housingStatus === "rent") ? "active" : ""} name="rent" onClick={this.props.setHousingStatus}>I rent</Button>
            <Button className={(this.props.housingStatus === "own") ? "active" : ""}  name="own" onClick={this.props.setHousingStatus}>I own</Button>
            <Button className={(this.props.housingStatus === "other") ? "active" : ""}  name="other" onClick={this.props.setHousingStatus}>Other</Button>
          </ButtonGroup>
          <FormFeedback>{this.props.validation.housingStatus.message}</FormFeedback>
        </FormGroup>                    
      </div>);
  }
}
HousingStatusFields.defaultProps= {
  setHousingStatus:() => {},
  validation: {
    housingStatus: {
      isInvalid: false,
      message: ""
    }
  }
};

HousingStatusFields.propTypes = {
  setHousingStatus: PropTypes.func,
};

export default HousingStatusFields;


// WEBPACK FOOTER //
// ./src/components/Fields/HousingStatusFields.js